/**
 * Mutation helpers for raw AI rule responses.
 */
import { isDescriptionCondition, updateConditionWithKeyword, } from './rule-keyword-utils';
export function changeAppliedCategory(rawRule, newCategoryId) {
    return {
        ...rawRule,
        conditions: {
            ...rawRule.conditions,
            result: {
                ...rawRule.conditions.result,
                value: rawRule.conditions.result.value.map((action) => {
                    if (action.actionType === 'set_category') {
                        return {
                            ...action,
                            actionValue: newCategoryId,
                        };
                    }
                    return action;
                }) ?? [],
            },
        },
    };
}
export function changeKeyword(rawRule, newKeyword, matchType = 'exact') {
    const field = rawRule.conditions?.and
        ? 'and'
        : rawRule.conditions?.or
            ? 'or'
            : undefined;
    if (!field)
        return rawRule;
    const result = {
        ...rawRule,
        conditions: {
            [field]: rawRule?.conditions?.[field]?.map((condition) => {
                if (isDescriptionCondition(condition)) {
                    return updateConditionWithKeyword(condition, newKeyword, matchType);
                }
                return condition;
            }) ?? [],
            result: {
                value: rawRule?.conditions?.result?.value?.map((action) => {
                    if (action.actionType === 'set_category') {
                        return {
                            ...action,
                            patternType: matchType,
                        };
                    }
                    return action;
                }) ?? [],
            },
        },
    };
    return result;
}
